module.exports = __webpack_public_path__ + "img/iaa-circle.e37063bf.png";